import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import sharedMessages from '@/lib/shared-messages';
import { useChemicanUrls } from '@/composables/useChemicanUrls';


export default /*#__PURE__*/_defineComponent({
  __name: 'LPHeaderMenuSp',
  props: {
  drawerOpened: Boolean,
},
  emits: ["toggleDrawer"],
  setup(__props, { emit }: { emit: ({
  (e: 'toggleDrawer', opened: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const drawer = computed({
  get: () => {
    return props.drawerOpened;
  },
  set: (opened: boolean) => {
    emit('toggleDrawer', opened);
  },
});

// 共通の URL 生成ロジックを使用
const { signupUrl, pricingUrl, featuresUrl, companyUrl } = useChemicanUrls();

return { __sfc: true,props, emit, drawer, signupUrl, pricingUrl, featuresUrl, companyUrl, sharedMessages }
}

})